import { atom } from "jotai";

export const orientationModalAtom = atom<boolean>(false);
export const orientationApplyModalAtom = atom<boolean>(false);
export const orientationAppliedModalAtom = atom<boolean>(false);
export const orientationCompletedModalAtom = atom<boolean>(false);
export const mktOrientationModalAtom = atom<boolean>(false);

export const leftDaysAtom = atom<number>(0);
